module.exports = __webpack_public_path__ + "static/media/sergio.7c9687d9.jpg";